import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import HarmonyOSOutlinedSvg from "@ant-design/icons-svg/es/asn/HarmonyOSOutlined";
import AntdIcon from "../components/AntdIcon";
var HarmonyOSOutlined = function HarmonyOSOutlined(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: HarmonyOSOutlinedSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  HarmonyOSOutlined.displayName = 'HarmonyOSOutlined';
}
export default /*#__PURE__*/React.forwardRef(HarmonyOSOutlined);